<template>
  <div class="XVdate">
    <div v-if="disabled" disabled="disabled" class="form-control internalmobileXVdate">{{ computedlocaldate }}</div>
    <input
      v-if="hasMobile && !disabled"
      class="form-control internalmobileXVdate"
      type="date"
      :disabled="disabled"
      v-model="computedhtml5date"
    />
    <div v-if="!hasMobile && !disabled">
      <div class="input-group">
        <span class="input-group-btn">
          <button @click="showpopup()" class="btn btn-primary calbtn" type="button">
            <font-awesome-icon class="fa-lg" :icon="['fal', 'calendar-alt']" />
          </button>
        </span>
        <input
          ref="myinput"
          class="form-control internalXVdate"
          type="text"
          :value="computedlocaldate"
          @blur="setlocaldate($refs.myinput.value)"
          v-on:keyup.enter="setlocaldate($refs.myinput.value)"
        />
        <span class="input-group-btn">
          <button class="btn btn-primary resetxvdate" @click="setlocaldate('')" type="button">
            <font-awesome-icon class="fa-lg" icon="times" />
          </button>
        </span>
      </div>
      <v-date-picker
        :min-date="new Date('1900-01-01')"
        mode="single"
        :is-required="false"
        v-model="selectedDate"
        @input="popupClickDate"
        :theme-styles="themeStyles"
        :tint-color="colors.primary"
        :formats="formats"
        :popover-visibility="popoverVisibilityComputed"
        :date-parser="formatStringdate"
        :input-props="{ class: 'hide' }"
      ></v-date-picker>
    </div>

    <p v-show="error" class="form__error">{{ error }}</p>
  </div>
</template>
<script>
import { FAMixin, util } from 'pevueglobal'
import { parse, format } from 'date-fns'
import { mapGetters } from 'vuex'
import { setupCalendar, DatePicker } from 'v-calendar'
import 'v-calendar/lib/v-calendar.min.css'
setupCalendar({
  firstDayOfWeek: 2,
  input: [PEGLOBALS.Xdateformat],
  locale: util.GetCulture()
})
export default {
  components: {
    'v-date-picker': DatePicker
  },
  $_veeValidate: {
    name() {
      return this.name
    },
    value() {
      return this.value
    }
  },
  mixins: [FAMixin],
  props: {
    focus: {
      type: Boolean,
      default: false
    },
    id: {
      type: String
    },
    value: {
      type: Date,
      default: null
    },
    formdata: {},
    disabled: {
      type: Boolean,
      default: false
    },
    validationName: {
      type: [String],
      default: null
    },
    error: {
      type: String,
      required: false
    }
  },
  data: function() {
    return {
      outsideClickListener: null,
      hasMobile: false,
      Xdateformat: PEGLOBALS.Xdateformat,
      selectedDate: null,
      popoverVisibility: false,
      themeStyles: {
        weekdays: {
          fontWeight: '600',
          fontSize: '1.1rem'
        },
        dayContent: {
          fontSize: '1.1rem'
        },
        dayCell: {
          padding: '5px 0'
        },
        navMonthCell: {
          fontSize: '1.1rem'
        },
        navYearCell: {
          fontSize: '1.1rem'
        },
        navHeaderTitle: {
          fontSize: '1.1rem'
        }
      },
      formats: {
        title: 'MMMM YYYY',
        weekdays: 'W',
        navMonths: 'MMM',
        input: [PEGLOBALS.Xdateformat.toUpperCase()], // Only for `v-date-picker`
        dayPopover: 'L', // Only for `v-date-picker`
        data: [PEGLOBALS.Xdateformat.toUpperCase()] // For attribute dates
      }
    }
  },
  methods: {
    hidepicker() {
      setTimeout(() => {
        this.popoverVisibility = false
      }, 200)
    },
    popupClickDate() {
      this.$emit('input', this.selectedDate)
      this.$emit('formvaluechanged', {
        type: this.$vnode.componentOptions.tag,
        value: this.selectedDate,
        id: this.id,
        formdata: this.formdata
      })

      this.popoverVisibility = false
    },
    formatStringdate(text) {
      if (text !== '') {
        let splitChar = '/'
        if (util.GetCulture() === 'nl-NL') {
          splitChar = '-'
        }

        let splitDate = []
        if (text.indexOf('-') !== -1) {
          splitDate = text.split('-')
        } else {
          splitDate = text.split('/')
        }

        // datum aanvulllen als alleen dag of dag en maand gegeven zijn

        if (splitDate.length === 1) {
          let d = new Date()
          let m = d.getMonth() + 1
          splitDate[1] = m.toString()
        }
        if (splitDate.length === 2) {
          let d = new Date()
          splitDate[2] = d.getFullYear().toString()
        }
        // voorloopnul toevoegen on blur of paste
        let index = 0
        let newd = ''
        for (let dparts of splitDate) {
          let dpartOutput = ''
          if (index === 0 || index === 1) {
            if (dparts.length === 1) {
              dpartOutput = '0' + dparts
            } else {
              dpartOutput = dparts
            }
            newd += dpartOutput + splitChar
          } else {
            newd += dparts
          }
          index++
        }
        return newd
      } else {
        return ''
      }
    },
    setlocaldate(val) {
      if (val === '') {
        this.$emit('input', null)
        this.$emit('formvaluechanged', {
          type: this.$vnode.componentOptions.tag,
          value: null,
          id: this.id,
          formdata: this.formdata
        })
      } else {
        val = this.formatStringdate(val) + ''
        let newd = parse(val, PEGLOBALS.Xdateformat, new Date())
        const selectedDate = new Date(this.selectedDate)
        if (
          newd.getDay() !== selectedDate.getDay() ||
          newd.getMonth() !== selectedDate.getMonth() ||
          newd.getYear() !== selectedDate.getYear()
        ) {
          this.$emit('input', newd)
          this.$emit('formvaluechanged', {
            type: this.$vnode.componentOptions.tag,
            value: newd,
            id: this.id,
            formdata: this.formdata
          })

          this.selectedDate = newd
        }
      }
    },
    hideOnClickOutside(element) {
      this.outsideClickListener = event => {
        if (!element.contains(event.target)) {
          // or use: event.target.closest(selector) === null
          this.popoverVisibility = false
          document.removeEventListener('click', this.outsideClickListener)
        }
      }

      document.addEventListener('click', this.outsideClickListener)
    },
    showpopup() {
      if (this.popoverVisibility) {
        document.removeEventListener('click', this.outsideClickListener)
        this.popoverVisibility = false
      } else {
        this.popoverVisibility = !this.popoverVisibility
        document.removeEventListener('click', this.outsideClickListener)
        setTimeout(() => {
          this.hideOnClickOutside(document.querySelector('.popover-container'))
        }, 500)
      }
    }
  },
  computed: {
    ...mapGetters(['colors']),
    popoverVisibilityComputed() {
      return this.popoverVisibility ? 'visible' : 'hidden'
    },
    computedhtml5date: {
      get() {
        if (this.value && this.value instanceof Date) {
          return format(this.value, 'yyyy-MM-dd')
        } else {
          return null
        }
      },
      set(val) {
        const inputValue = val ? new Date(val) : null
        this.$emit('input', inputValue)
        this.$emit('formvaluechanged', {
          type: this.$vnode.componentOptions.tag,
          value: inputValue,
          id: this.id,
          formdata: this.formdata
        })
      }
    },
    computedlocaldate() {
      if (this.value === null) {
        return ''
      } else if (this.value instanceof Date && !isNaN(this.value)) {
        var str = format(this.value, PEGLOBALS.Xdateformat)
        return str
      } else {
        return this.$refs.myinput.value
      }
    }
  },
  mounted() {
    if ($('html').hasClass('mobile')) {
      this.hasMobile = true
    } else {
      setTimeout(() => {
        this.selectedDate = this.value
      }, 500)
    }
  }
}
</script>
<style scoped>
.XVdate .btn {
  border-color: #ccc !important;
  box-shadow: none !important;
}
.vc-text-sm {
  font-size: 1rem !important;
}
.vc-text-lg {
  font-size: 1.1rem !important;
}
.vc-reset input {
  line-height: 1.428571429;
  box-sizing: border-box;
  border: 1px solid #ccc;
}
.calbtn,
.btnremovedate {
  border-width: 1px !important;
  line-height: 1.428571429 !important;
}
</style>
